import './index.less';
import * as React from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import useDelayedFlag from '@src/utils/hooks/use-delayed-flag';
import { centerElementInViewport } from '@src/utils/scroll-initial-position';
import CommonLoading from '@src/components/common-loading';
import Page from '@src/components/page';
import MoVeteranReviewStages from '@src/ui-components/mo-veteran-review-stages';
import MoVeteranReviewSummary from '@src/ui-components/mo-veteran-review-summary';
import VeteranReviewStore from './store';

const styles = require('./index.less');

const VeteranReviewContent = () => {
  const { activitySessionStore } = React.useContext(MobXProviderContext);
  const store = useStore(() => new VeteranReviewStore({ activitySessionStore }));
  // 短于 300ms 的加载不渲染遮罩：缓存命中/快速响应不闪屏，慢请求照常出现
  const showLoading = useDelayedFlag(store.loadStatus === 'loading');
  const stage = store.stage;

  // 2026-09-22 需求：首页与回顾阶段页进入时主体垂直居中——
  // home 居中回顾首页主体（group14，mount 即 stage=home 首跑覆盖进页场景）；
  // review 居中卷轴内容页（group1，转场动画仅 clip-path/opacity 不影响 rect 量测）；
  // summary 保持现状不定位。centerElementInViewport 内部经 rAF 延后一帧，
  // 等 html rem 基准（AppRouter didMount 设置）生效后再量几何，避免文档高度不足滚动被吞
  React.useEffect(
    () => {
      if (stage === 'home') {
        centerElementInViewport(document.querySelector('[data-name="回顾首页"]'));
      } else if (stage === 'review') {
        centerElementInViewport(document.querySelector('[data-name="回顾内容页"]'));
      }
    },
    [stage]
  );
  const summaryVisible = store.stage === 'summary';
  const teamState = {
    status: store.teamLoadStatus,
    hasTeam: Boolean(store.teamViewModel && store.teamViewModel.hasTeam)
  };

  return (
    <Page className={styles.root}>
      <MoVeteranReviewStages
        className={summaryVisible ? styles.leavingPhase : undefined}
        phase={store.stage}
        sections={store.sections}
        currentIndex={store.currentReviewIndex}
        reviewStatus={store.reviewStatus}
        swiperStore={store.swiperStore}
        completionPending={Boolean(store.finishPromise)}
        onStart={store.loadStatus === 'error' ? store.initialize : store.handleStartReview}
        onSkip={store.handleSkipReview}
        onIndexChange={store.handleReviewIndexChange}
        onReachEnd={store.completeReview}
      />
      <MoVeteranReviewSummary
        className={!summaryVisible ? styles.hiddenPhase : styles.enteringPhase}
        viewModel={store.summaryViewModel}
        teamState={teamState}
        onPosterAction={store.handlePosterAction}
        onBack={store.handleBackToHome}
      />
      {showLoading ? (
        <div className={styles.loading} data-name="回顾加载中">
          <CommonLoading />
        </div>
      ) : null}
    </Page>
  );
};

const ObservedVeteranReviewContent = observer(VeteranReviewContent);

const VeteranReview = () => <ObservedVeteranReviewContent />;

export default VeteranReview;
